export const state = {
  version: '', //Cache App Version
  AccountType: '', //Account Type of Current User
  Accounts: [],
  Bills: [],
  Budgets: [],
  Categories: [],
  Currencies: [],
  CurrencyConversions: [],
  Expenses: [],
  Incomes: [],
  Items: [],
  Notifications: [],
  Transactions: [],
  TransactionItems: [],
  Transfers: [],

  //Saves Night Mode Selection on device
  NightMode: {
    switch: '',
    topNav: 'light-mode',
    sideNav: 'light-mode',
    itemCard: 'itemCardlight'
  }, 


}



// WEBPACK FOOTER //
// ./src/store/state.js